import * as layout from '../../../components/markLayout.module.css';
import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import useValidateDrip from '../../../api/useValidateDrip';
import type { DripValidationDestination } from '../../../constants';
import { extractDripErrorCodes } from '../dripFormUtils';
import DripValidationMessages from './DripValidationMessages';

type Props = {
    dripId: number;
    onNavigate: (destination: DripValidationDestination) => void;
};
const ValidateBanner: React.FC<Props> = ({ dripId, onNavigate }) => {
    const { data, isLoading, isRefetching, error, refetch } = useValidateDrip(dripId);
    if (isLoading) {
        return (
            <P
                noDefaultMargin
                size="small"
                styles={{
                    color: 'var(--mark-muted)',
                    padding: '0.4rem 0'
                }}
            >
                Validating…
            </P>
        );
    }
    if (!data && !error) return null;
    const valid = !error && data?.valid === true;
    return (
        <div
            role={valid ? 'status' : 'alert'}
            className={valid ? layout.panel : layout.notice}
            style={{
                backgroundColor: valid
                    ? 'var(--mark-success-surface)'
                    : 'var(--mark-danger-surface)',
                marginBottom: '1rem'
            }}
        >
            {valid ? (
                <>
                    <P noDefaultMargin styles={{ color: 'var(--mark-success)' }}>
                        Validation passed.
                    </P>
                    <P noDefaultMargin size="small">
                        Checks use the draft when available, otherwise the current version. Mark
                        must also be enabled when activating.
                    </P>
                </>
            ) : (
                <DripValidationMessages
                    codes={error ? extractDripErrorCodes(error) : (data?.errors ?? [])}
                    onNavigate={onNavigate}
                />
            )}
            <MarkButton
                onClick={() => refetch()}
                disabled={isRefetching}
                style={{ marginTop: '0.8rem' }}
            >
                {isRefetching ? 'Checking…' : 'Re-validate'}
            </MarkButton>
        </div>
    );
};
export default ValidateBanner;
